import React from 'react'
import './style.css'
import Testimonial from './SwiperTestimonial'
import { Link } from 'gatsby'

const OurTeam = () => (
  <section id="testimonial">
    <div className="testimon">
      <div className="container">
        <div className="headtest">
          <span>OUR</span>
          <h2>Recommendations</h2>
        </div>
        <Testimonial slidesperview={1}>
          <div>
            <p className="dettst">
              Daniel was amazing! His passion and drive along with his ethics in
              the real estate industry were beyond our expectations. As a former
              builder employee, his integrity and knowledge of our partic
            </p>
            <div className="authortest">
              <span>Aryn Spurgeon</span>
              <p>From Realtor.com</p>
            </div>
          </div>
          <div>
            <p className="dettst">
              Dan stayed completely optimistic throughout the entire process. He
              made sure to get us the best offer and always communicated with us
              very well on any updates. It was great working with Dan and
            </p>
            <div className="authortest">
              <span>Nathalie Ward</span>
              <p>From Realtor.com</p>
            </div>
          </div>
          <div>
            <p className="dettst">
              He is really help me to buy a beautiful house. He is a an
              excellent real estate agent. He is available anytime you call and
              willing to come when you need to see the house.
            </p>
            <div className="authortest">
              <span>Dimawe</span>
              <p>From Realtor.com</p>
            </div>
          </div>
          <div>
            <p className="dettst">
              Dan Armstrong has been our realtor for years. We have built and
              sold several homes, and just recently sold our rental property.
              We've always had such a good experience working with Dan. He is
              knowledgeable, hard-working, and trustworthy. I would highly
              recommend Dan to anyone looking for a realtor.
            </p>
            <div className="authortest">
              <span>candacefieber</span>
              <p>From Zillow.com</p>
            </div>
          </div>
          <div>
            <p className="dettst">
              Dan is a master of his craft. He understands the market and does
              not set unrealistic expectations for a buyer or seller. He listens
              to his customers and keeps their best interests in mind. He is
              always extremely polite and respectful fostering a friendship
              instead of just a business relationship.
            </p>
            <div className="authortest">
              <span>djhembree</span>
              <p>From Zillow.com</p>
            </div>
          </div>
          <div>
            <p className="dettst">
              If you want your house sold quickly, look no further. My house was
              sold on the first day of showings, in 5 hours! Knowledge of the
              market, pricing and bringing the right buyer to our home was the
              key.
            </p>
            <div className="authortest">
              <span>TjD</span>
              <p>From Zillow.com</p>
            </div>
          </div>
        </Testimonial>
      </div>
    </div>
  </section>
)

export default OurTeam
